import { useSelector } from "react-redux";

export const useCurrentPlayer = () => useSelector((state) => state.player.player);
